import { supabase } from "./supabase.ts";
import { emptyAnswer, withDeadline } from "./requests.ts";
import type { Venue, VenueChanges, VenueDetail } from "./venues.ts";

export interface VenueSave extends VenueChanges { id: string; expected_token: string | null; request_id: string }
export interface VenueApi {
  list(): Promise<Venue[]>;
  detail(id: string): Promise<VenueDetail>;
  save(request: VenueSave): Promise<VenueDetail>;
}
function detailResult(data: unknown): VenueDetail {
  const d = data as VenueDetail | null;
  if (!d?.venue?.id || !d.venue.edit_token || !Array.isArray(d.bin_zones) || !Array.isArray(d.staff_schedule)) throw emptyAnswer;
  return d;
}
export const venueApi: VenueApi = {
  async list() {
    const r = await withDeadline((signal) => supabase.rpc("get_venue_picker").abortSignal(signal));
    if (r.error) throw { ...r.error, status: r.status };
    if (!Array.isArray(r.data)) throw emptyAnswer;
    return r.data as Venue[];
  },
  async detail(id) {
    const r = await withDeadline((signal) => supabase.rpc("get_venue_for_edit", { p_id: id }).abortSignal(signal));
    if (r.error) throw { ...r.error, status: r.status };
    return detailResult(r.data);
  },
  async save(r) {
    const response = await withDeadline((signal) => supabase.rpc("save_venue", {
      p_id: r.id, p_expected_token: r.expected_token, p_request_id: r.request_id,
      p_changes: r.changes, p_bin_zones: r.bin_zones, p_staff_schedule: r.staff_schedule,
    }).abortSignal(signal), 30_000);
    if (response.error) throw response.error;
    return detailResult(response.data);
  },
};
